import { join } from 'node:path';
import { getDataDirPath } from '@wix/cli-data-dir';
import { pathExists, readJson, writeJson } from '@wix/cli-fs';
import {
  userConfigSchema,
  USER_CONFIG_FILENAME,
} from '@wix/cli-core-definitions';
import type { UserConfig } from '@wix/cli-core-definitions';

function getUserConfigPath() {
  return join(getDataDirPath(), USER_CONFIG_FILENAME);
}

export async function readUserConfig() {
  const configPath = getUserConfigPath();
  const isConfigExist = await pathExists(configPath);
  const json = isConfigExist ? await readJson(configPath) : {};
  return userConfigSchema.parse(json);
}

export async function updateUserConfig(config: Partial<UserConfig>) {
  const currentConfig = await readUserConfig();
  const newConfig = {
    ...currentConfig,
    ...config,
  };

  const configPath = getUserConfigPath();
  await writeJson(configPath, newConfig);
}
